<template>
  <v-container 
    id="data-tables" 
    tag="section"
    fluid
  >
    <base-material-card
      color="primary"
      icon="mdi-chart-bubble"
      inline
      class="px-5 py-4 ml-0"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Índices COGE</div>
      </template>

      <v-col cols="12">
        <v-alert 
          dense
          outlined 
          type="warning"
          class="mt-3 py-0 px-1"  
          >
            <b>Atenção:</b> os registros alterados nessa tela são replicados em todos os sistemas.
        </v-alert>
      </v-col>

      <v-btn
        id="btn-nova-importação-indices"
        class="mt-3"
        color="success"
        dark
        elevation="1" 
        style="float: left"
        relative
        text
        medium
        @click="$router.push('edit')"
      >
        <v-icon left size="30px"> mdi-plus-circle </v-icon>
        IMPORTAR
      </v-btn>

      <v-text-field
        id="indices-historico-search"
        append-icon="mdi-magnify"
        class="ml-auto break-search "
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
        v-model="search"
      />

      <v-divider class="mt-10" />

      <v-data-table
      :headers="headers"
      :items="indiceCOGE"
      :headerProps="{ sortByText: 'Ordenar Por' }"
      :footer-props="{ itemsPerPageText: 'Itens por Página' }"
      :search.sync="search"
      :loading="loading"
      no-data-text="Nenhuma data disponível"
      no-results-text="Nenhum registro correspondente encontrado"
      >
        <template v-slot:[`item.dataRegistro`]="{ item }">{{ formatDate(item.dataRegistro) }}</template>
        <template v-slot:[`item.actions`]=" { item } ">
          <v-btn
          id="action-download-indices"
          x-small
          class="px-3"
          icon
          @click="openDialogDownload(formatDateToPicker(item.dataRegistro))"
          >
            <v-icon>
              mdi-download
            </v-icon>
          </v-btn>
          <v-btn
          id="indices-action-view"
          class="px-3"
          x-small
          icon
          @click="$router.push(`visualizar/${formatDateToPicker(item.dataRegistro)}`)"
          >
            <v-icon>
              mdi-file-eye-outline
            </v-icon>
          </v-btn>
          <v-btn
          id="indices-action-trash"
          class="px-3"
          x-small
          icon
          @click="openDialogDelete(formatDateToPicker(item.dataRegistro))"
          >
            <v-icon>
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>

    </base-material-card>
    <dialog-delete 
    :showDialog="dialogDelete"
    @changeValue="dialogDelete = $event"
    @deleteTriggered="deletarItem(dialogDeleteData)"
    >
      <template slot="title"> Deletar Importação Mês #{{ formatDate(dialogDeleteData)}}</template>
      <template slot="body"> Tem certeza que deseja deletar a Importação do mês <strong>{{ formatDate(dialogDeleteData) }}?</strong></template>
    </dialog-delete>
    
  </v-container>
</template>
<script>

import DateFormatterMixins from "@/mixins/dateFormatterMixins.js";
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';
import IndicesCOGE from "@/services/IndicesCOGEService";

export default {
  name: "DataRegistroDataTable",

  components: {
    DialogDelete: () => import('@/components/general/DialogDelete.vue'),
    GeneralProgressBars: () => import("@/components/general/GeneralProgressBars.vue"),
  },

  props: {
    indiceCOGE: {
        type: Array,
        default: () => []
    },
    loading: {
        type: Boolean,
        default: false,
    }
  },

  mixins: [DateFormatterMixins, powerupsActionsMixins],

  data: () => ({
    powerupService: IndicesCOGE,
    powerupEntityName: "Índice COGE",
    downloadProgressData: {},
    search: "",
    headers: [
        {
            text: "Data de Registro",
            value: "dataRegistro"
        },
        {
            sortable: false,
            text: "Ações",
            value: "actions",
            class: "pl-1"
        }
    ]
  }),
  methods: {
    openDialogDelete(data_registro){
      this.dialogDelete = true;
      this.dialogDeleteData = data_registro;
    },
    openDialogDownload(data_registro){

      this.$set(this.downloadProgressData, data_registro, {data_registro})
      this.$toast.info(`Gerando arquivo para download...`, "", { position: "topRight", timeout: 2000 });
      IndicesCOGE.exportar(data_registro, {
        timeout: 60 * 60 * 1000,
        onDownloadProgress: (progressEvent) => {
          let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          let isComputable = progressEvent.lengthComputable;

          this.$set(this.downloadProgressData, data_registro, {progress, isComputable, data_registro});
        }
      })
        .then(async response => {
          const url = window.URL.createObjectURL(new Blob ([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `indice-coge-${data_registro}.csv`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
        this.$toast.error("Erro ao disponibilizar o download", "", { position: "topRight"});
        console.error(err);
      })
      .finally(() => {
        this.$delete(this.downloadProgressData, data_registro);
      });
    }
  }
};
</script>